import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VListItem,{attrs:{"disabled":_vm.item.period.disabled,"value":_vm.item.period.identifier},on:{"click":function($event){return _vm.selectPeriod(_vm.item.period)}}},[_c(VListItemTitle,{domProps:{"textContent":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }